import api, { API_VERSIONS } from "@/config/api";
import { AxiosError } from "axios";
import { recoverTokenInfo } from "../utils/recoverTokenInfo";

export const getUserInfo = async (): Promise<string | AxiosError | undefined> => {
  try {
    const initialToken = recoverTokenInfo();
    if (!initialToken) return "";

    const res = await api.get<string>(`/${API_VERSIONS.v0}/info`, {
      headers: {
        Accept: "*/*",
        Authorization: `Bearer ${initialToken}`,
      },
    });

    if (!res.data) return "";
    return res.data;
  } catch (error) {
    console.error("Error fetching user info:", error);
    throw error;
  }
};
